import { PRICE_ALERT_TYPE } from '@models/price-alerts.class';

export const baseCode = 'MDVjMEMjaU4zQHwyMyg6Myk=';

/**
 * TODO: Add the rest of the routes
 * and replace them where needed
 */
export const appRoutes = {
  bankAccount: '/main/cuenta-bancaria',
  privacyAdvice: 'https://auth.gbm.com/docs/aviso-de-privacidad.pdf',
};

export enum DocumentationStatus {
  migrationSituation = 0,
  accountType = 1,
  callCAC = 2,
}

export enum CanvasMonitorColumnType {
  any = 0,
  boolean = 1,
  string = 2,
  money = 3,
  percentage = 4,
  integer = 5,
}

export enum CanvasMonitorFlag {
  none = 0,
  up = 1,
  down = 2,
}

export enum ORDER_TYPE {
  UNDEFINED = 0,
  COMPRANORMAL = 1,
  VENTANORMAL = 8,
  VENTACORTO = 13,
  COMPRAGLOBAL = 16,
  VENTAGLOBAL = 18,
  COMPRAMPLACTIVA = 44,
  VENTAMPLACTIVA = 45,
  COMPRAMPLPASIVA = 46,
  VENTAMPLPASIVA = 47,
  COMPRAMPLSENTIDOOPUESTO = 60,
  VENTAMPLSENTIDOOPUESTO = 61,
  COMPRAMPLVOLUMENOCULTO = 62,
  VENTAMPLVOLUMENOCULTO = 63,
}

export const buyOrderTypes = [
  ORDER_TYPE.COMPRANORMAL,
  ORDER_TYPE.COMPRAGLOBAL,
  ORDER_TYPE.COMPRAMPLACTIVA,
  ORDER_TYPE.COMPRAMPLPASIVA,
  ORDER_TYPE.COMPRAMPLSENTIDOOPUESTO,
  ORDER_TYPE.COMPRAMPLVOLUMENOCULTO,
];

export enum ALGORITHM_TYPE {
  UNDEFINED = 0,
  STATICICEBERG = 1,
  DYNAMICICEBERG = 2,
  TIMEDICEBERG = 3,
  BESTEXECUTIONATSCALEMARKET = 4,
  BESTEXECUTIONATSTATICMARKET = 5,
  STOPMARKET = 6,
  STOPLIMIT = 7,
  TRAILINGSTOP = 15,
  ONECANCELANOTHER = 16,
  ONETRIGGERSANOTHER = 20,
}

export const PositionGroups = [
  // tslint:disable-line
  { id: 0, name: 'Consolidado', visible: true },
  { id: 1, name: 'Mercado de Capitales', visible: true },
  { id: 2, name: 'Fondos de Inversión', visible: true },
  { id: 3, name: 'Otros', visible: true },
  { id: 4, name: 'Efectivo', visible: true },
];

export const PositionValueTypes = [
  // tslint:disable-line
  { id: 0, name: 'Mercado de Capitales Global (SIC)' },
  { id: 1, name: 'Mercado de Capitales Nacional' },
  // { id: 2, name: 'Sociedades de Inversión Común' },
  { id: 2, name: 'Fondos de Inversión Renta Variable' },
  { id: 3, name: 'Mercado de Dinero Directo' },
  { id: 4, name: 'Valores en Reporto' },
  { id: 5, name: 'Fondos de Inversión Deuda' },
  { id: 6, name: 'Valores Obtenidos en Préstamo' },
  { id: 7, name: 'Valores Otorgados en Préstamo' },
  { id: 8, name: 'Garantías Préstamo' },
  { id: 9, name: 'Garantías Caución' },
  { id: 10, name: 'Fondos de Inversión Renta Variable' },
  { id: 11, name: 'Custodia Prestatario' },
  { id: 12, name: 'Divisas' },
  { id: 15, name: 'Fondo de Fondos' },
  { id: 25, name: 'Corto Administrativo' },
  { id: 26, name: 'Venta en Corto' },
  { id: 27, name: 'Efectivo' },
  { id: 28, name: 'Dolares' },
  { id: 29, name: 'Dolares Citibank' },
  { id: 30, name: 'Mercado de Derivados' },
  { id: 33, name: 'Santander' },
  { id: 37, name: 'Bancomer' },
  { id: 45, name: 'PREF' },
  { id: 46, name: 'PR65' },
  { id: 47, name: 'Crédito Margen' },
  { id: 48, name: 'Garantías Margen' },
  { id: 49, name: 'Caución Derivados' },
  { id: 50, name: 'Caución OTC' },
  { id: 51, name: 'Retiro Mayor' },
  { id: 60, name: 'Valores en Garantías TP' },
  { id: 80, name: 'Derivados' },
  { id: 90, name: 'Posición Equivalente de Fondos en Dolares' },
  { id: 97, name: 'Garantías en Préstamo 97' },
  { id: 100, name: 'Mercado Capitales Global' },
  { id: 101, name: 'Vacio' },
  { id: 111, name: 'Dolares 111' },
  { id: 150, name: 'Efectivo Margen' },
  { id: 1000, name: 'Total Portafolio' },
];

export enum FUND_TYPES {
  EQUITY = 2,
  DEBT = 5,
}

export enum FUND_INSTRUMENT_TYPES {
  EQUITY = 28,
  DEBT = 27,
}

const loader = `
<div class="loader" style="position: absolute; z-index: 9999; left: 50%; top: 50%;">
  <div class="loader-inner ball-scale-multiple">
    <div class="hb-loader"></div>
    <div class="hb-loader"></div>
    <div class="hb-loader"></div>
  </div>
</div>
`;

export const VIGENCIA = [
  { id: 1, name: '1 día' },
  { id: 2, name: '2 días' },
  { id: 3, name: '3 días' },
  { id: 4, name: '4 días' },
  { id: 5, name: '5 días' },
  { id: 6, name: '6 días' },
  { id: 7, name: '7 días' },
  { id: 8, name: '8 días' },
  { id: 9, name: '9 días' },
  { id: 10, name: '10 días' },
  { id: 11, name: '11 días' },
  { id: 12, name: '12 días' },
  { id: 13, name: '13 días' },
  { id: 14, name: '14 días' },
  { id: 15, name: '15 días' },
  { id: 16, name: '16 días' },
  { id: 17, name: '17 días' },
  { id: 18, name: '18 días' },
  { id: 19, name: '19 días' },
  { id: 20, name: '20 días' },
];

export interface WatchlistItemConfig {
  watchlistId: number;
  watchlistName: string;
  watchlistEdit: boolean;
  configuration: string;
  index?: number;
  issueConfig?: any[];
}

export enum ToolTipRelativePosition {
  RIGHT = 0,
  TOP = 1,
  BOTTOM = 2,
  LEFT = 3,
}

export const SOLACE_SUBSCRIPTIONS = {
  MONITOR_BMV: 'dat/GBM/R/MDWEB/MEX/E/BMV/NAC/',
  MONITOR_BMV_VOL: 'dat/GBM/R/AGG/MEX/E/BMV/NAC/',
  INDICES: 'dat/GBM/R/Indices2/MEX/*',
  PROFUNDIDAD1_BMV: 'dat/GBM/R/L1/MEX/E/BMV/NAC/',
  PROFUNDIDAD1_SIC: 'dat/GBM/R/L1/MEX/E/BMV/SIC/',
  PROFUNDIDAD2_BMV: 'dat/GBM/R/L2/MEX/E/BMV/NAC/',
  PROFUNDIDAD2_SIC: 'dat/GBM/R/L2/MEX/E/BMV/SIC/',
  MONITOR_SIC_VOL: 'dat/GBM/R/AGG/MEX/E/BMV/SIC/',
  MONITOR_SIC: 'dat/GBM/R/MDWEB/MEX/E/BMV/SIC/',
};

export const USER_ROLES = {
  RI: 16,
  SUBDIRECTOR: 17,
  ADVISOR: 18,
  STANDARD: 19,
  READONLY: 21,
};

export const ORDERS_LIST = [
  { id: '1', name: 'Limitada', globalViewable: true },
  { id: '2', name: 'En Línea, a mercado (MKT)', globalViewable: true },
  { id: '3', name: 'MPL Activa', globalViewable: true },
  { id: '4', name: 'MPL Pasiva', globalViewable: true },
  { id: '5', name: 'MPL Volumen Oculto', globalViewable: true },
  { id: '6', name: 'One Cancel Another(OCA)', globalViewable: true },
  { id: '7', name: 'One Triggers Another(OTA)', globalViewable: true },
  { id: '8', name: 'Stop en Línea', globalViewable: true },
  { id: '9', name: 'Stop Limitado', globalViewable: true },
  { id: '10', name: 'Trailing Stop', globalViewable: false },
  { id: '11', name: 'Venta en Corto', globalViewable: false },
];

export const SESSION_LENGTH = {
  INACTIVITY: 20,
};

export const BANK_ACCOUNT_REGISTER_TYPE = [
  'Número CLABE',
  'Deben ser 18 dígitos',
  'Tarjeta de débito',
  'Deben ser 16 dígitos',
  '0000 0000 0000 0000',
  'Ocurrió un error al subir tu archivo',
  'Tu archivo excede los 10 Mb',
  'Formato no válido',
];

export const BANK_ACCOUNT_FLOW_STATUS = {
  NEW: 'NEW',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  VERIFIED: 'VERIFIED',
  NOT_VISIBLE: 'NOT_VISIBLE',
  TRY_DELETE: 'TRY_DELETE',
  VALIDATE_ACCOUNT_SENT: 'VALIDATE_ACCOUNT_SENT',
  DOCUMENT_PENDING_VERIFICATION: 'DOCUMENT_PENDING_VERIFICATION',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  UPLOAD: 'DELETE_ACCOUNT',
};

export const HTTP_STATUS_CODE = {
  SUCCESS: 200,
  SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  FAILED_OR_CANCELED: 0,
};

export const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  STAGE: 'stage',
  PRODUCTION: 'production',
};

export const OPENING_STATUS = {
  ACTIVE: 'active',
  IN_PROGRESS: 'in_progress',
  NO_CONTRACT: 'no_contract',
  PENDING_REPLICATION: 'pending_replication',
  PENDING_TO_SIGN: 'pending_to_sign',
  PENDING_VERIFY_DOCUMENTS: 'pending_document_verification',
  REJECTED: 'document_verification_rejected',
  PARTY_INFORMATION_MISMATCH: 'party_information_mismatch',
};

export const AM_OWNERSHIP_TYPE = {
  OWNER: 'OWNER',
  THIRD_PARTY: 'THIRD_PARTY',
};

export const AM_BANK_ACCOUNT_TYPE = {
  CLABE: 'CLABE',
  DEBIT_CARD: 'DEBIT_CARD',
  TELEPHONE: 'TELEPHONE',
  NUMBER: 'NUMBER',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
};

export const AM_BANK_ACCOUNT_STATUS = {
  REGISTERED: 'registered',
  PENDING: 'pending',
  VERIFIED: 'verified',
  DELETED: 'deleted',
  FAILED: 'failed',
  PENDING_VERIFICATION: 'pending_verification',
  REQUIRED_MANUAL_VERIFICATION: 'required_manual_verification',
  MANUAL_INTERVENTION_APPLIED: 'manual_intervention_applied',
  FAILED_WITH_DOCUMENTS: 'FAILED_WITH_DOCUMENTS',
};

export const AM_DOCUMENT_STATUS = {
  LOADED: 'loaded',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const LEGAL_PERSONALITY_TYPE = {
  PHYSICAL_PERSON: 1,
  MORAL_PERSON: 2,
};

export const CONTRACT_CONFIGURATION = {
  DEFAULT: 'no-default',
};

export enum FULL_MODAL_ACTIONS {
  confirmation = 0,
}

export const CANCEL_TRANSFERS_STATUS = {
  accepted: 'accepted',
  rejected: 'rejected',
};

/**
 * Maybe we could refactor this so instead of containing
 * each event at root level, they're contained within a keyword
 * that can group multiple events.
 */
export const TRACKING_EVENTS = {
  account_detail: {
    event: 'account_detail',
  },
  clabe_copied: {
    event: 'clabe_copied',
  },
  view_withdrawal_form: {
    event: 'view_withdrawal_form',
  },
  withdrawal: {
    event: 'withdrawal',
  },
  has_deposit_trading: {
    event: 'has_deposit_trading',
    success: {
      Callback: 'Success',
    },
  },
  screen_edit_strategy: {
    event: 'edit_strategy_name_view',
  },
  edit_strategy_name: {
    event: 'edit_strategy_name',
  },
  screen_transfer: {
    event: 'screen_transfer',
  },
  transfer: {
    event: 'transfer',
  },
  start_trade: {
    event: 'start_trade',
  },
  trade: {
    event: 'trade',
  },
  send_order_cancelation: {
    event: 'send_order_cancelation',
    success: {
      Callback: 'Success',
      Success: 'true',
      Type: 'Trading',
    },
    error: {
      Success: 'false',
      Type: 'Trading',
    },
  },
  screen_orders: {
    event: 'orders_screen',
    success: {
      Callback: 'Success',
      Success: 'true',
      Type: 'Trading',
    },
  },
  screen_watchlist: {
    event: 'watchlist_screen',
    success: {
      Callback: 'Success',
      Success: 'true',
      Type: 'Trading',
    },
  },
  watchlist_add: {
    event: 'watchlist_add',
    success: {
      Callback: 'Success',
      Success: 'true',
      Type: 'Trading',
    },
    error: {
      Success: 'false',
      Type: 'Trading',
    },
  },
  screen_market: {
    event: 'screen_stock_market',
    success: {
      Callback: 'Success',
      Success: 'true',
      Type: 'Trading',
    },
  },
  movements_screen: {
    event: 'movements_screen',
  },
  movements_filter_period: {
    event: 'movements_filter_period',
    success: {
      Callback: 'Success',
      Success: 'true',
      Type: 'Trading',
    },
    error: {
      Success: 'false',
      Type: 'Trading',
    },
  },
  add_bank_account: {
    event: 'add_bank_account',
    success: {
      Success: 'true',
      Callback: 'Success',
      Type: 'Trading',
    },
    error: {
      Success: 'false',
      Type: 'Trading',
    },
  },
  delete_bank_account: {
    event: 'delete_bank_account',
    success: {
      Success: 'true',
      Callback: 'Success',
      Type: 'Trading',
    },
    error: {
      Success: 'false',
      Type: 'Trading',
    },
  },
  bank_account_status: {
    event: 'bank_account_status',
    success: {
      Success: 'true',
      Callback: 'Success',
      Type: 'Trading',
    },
    error: {
      Success: 'false',
      Type: 'Trading',
    },
  },
  price_alert_view: {
    event: 'price_alert_view',
  },
  day_trades_info_click: {
    event: 'day_trades_info_click',
  },
  price_alert_create: {
    event: 'price_alert_create',
    success: (type: PRICE_ALERT_TYPE, stock: string) => ({
      callback: 'success',
      type,
      stock,
    }),
    error: (type: PRICE_ALERT_TYPE, stock: string, error: any) => ({
      callback: error,
      type,
      stock,
    }),
  },
  price_alert_update: {
    event: 'price_alert_update',
    success: (type: PRICE_ALERT_TYPE) => ({
      callback: 'success',
      type,
    }),
    error: (type: PRICE_ALERT_TYPE, error: any) => ({
      callback: error,
      type,
    }),
  },
  price_alert_delete: {
    event: 'price_alert_update',
    payload: (stock: string) => ({
      stock,
    }),
  },
  external_funds_view: {
    event: 'external_funds_view',
    success: {
      Type: 'Trading',
    },
  },
  geolocation_timeout: {
    event: 'geolocation_timeout',
    payload: (callback: string) => ({ callback }),
  },
  geolocation_notallowed: {
    event: 'geolocation_notallowed',
    payload: (callback: string) => ({ callback }),
  },
  get_user_role: {
    event: 'get_user_role',
    success: (type: string) => ({
      Success: 'true',
      callback: 'Success',
      Type: type,
    }),
    error: (error: any) => ({
      Success: 'false',
      callback: error,
    }),
  },
  historical_filter_date: {
    event: 'historical_filter_date',
    success: (type: string) => ({
      callback: 'Success',
      Type: type,
    }),
  },
  news_category_view: {
    event: 'news_category_view',
    success: (category: any, newsItems: number) => ({
      Success: 'true',
      Callback: 'success',
      Type: 'Trading',
      Category: category,
      Total: newsItems,
    }),
    error: (category: any, error: any) => ({
      Success: 'false',
      Type: 'Trading',
      Category: category,
      Callback: error,
    }),
  },
  news_ticker_click: {
    event: 'news_ticker_click',
    payload: (stock: string, newsId: number) => ({
      Ticker: stock,
      Type: 'Trading',
      Id: newsId,
    }),
  },
  news_ticker_detail_view: {
    event: 'news_ticker_detail_view',
    success: (ticker: string, newsId: number) => ({
      Success: 'true',
      Callback: 'Success',
      Type: 'Trading',
      Ticker: ticker,
      Id: newsId,
    }),
    error: (ticker: string, error: any) => ({
      Success: 'false',
      Type: 'Trading',
      Ticker: ticker,
      Callback: error,
    }),
  },
  trade_blocked_liquidate_only: {
    event: 'trade_blocked_liquidate_only',
    success: {
      Type: 'Trading USA',
    },
  },
  coachmark: {
    event: 'coach_mark',
  },
  user_ignores_banner_tg_mx: {
    event: 'user_ignores_banner_tg_mx',
    success: (origin: string) => ({
      Origin: origin,
      Type: 'Trading',
    }),
  },
  user_clicks_banner_tg_mx: {
    event: 'user_clicks_banner_tg_mx',
    success: (origin: string) => ({
      Origin: origin,
      Type: 'Trading',
    }),
  },
  help: {
    event: 'help',
    success: (origin: string) => ({
      Origin: origin,
      Source: 'Trading',
    }),
  },
};

export enum FUNDS_ALLOCATION {
  gbm = 0,
  external = 1,
}

export enum ORDER_TYPE_LIST {
  limit = 1,
  inLine = 2,
  mplActive = 3,
  mplPasive = 4,
  mplHideVolume = 5,
  oca = 6,
  ota = 7,
  stopInLine = 8,
  stopLimit = 9,
  trailingStop = 10,
  shortSell = 11,
}

export const GEOLOCATION_NOTIFICATION_MESSAGE =
  'Habilita el permiso de ubicación para que puedas retirar, transferir, comprar y vender.';

export enum FUNDS_OPERATION_UNITS {
  amount = 'amount',
  titles = 'titles',
}

export const DEFAULT_STRATEGY_NAME = 'Trading';

export const CASH_LAYERS = {
  cashToday: 'Hoy',
  cash24hrs: '24 horas',
  cash48hrs: '48 horas',
};

export const DW_ACCOUNT_STATUS_TYPE = {
  pending: 'PENDING',
  open: 'OPEN',
  closed: 'CLOSED',
  open_no_new_trades: 'OPEN_NO_NEW_TRADES',
};
